export const MIN_CHILDREN_NUMBER = 4
export const DATA_SELECTOR_ATTRIBUTE_FOR_SEO = 'landing-navigation'
